import "@story/story_assets/modules/base";
import { onDocumentReady } from "@story/story_assets/utils";
import { initContactsMap } from "./components/contacts_map";

(function() {

	// *************************************************************************
	// SMap loading
	// *************************************************************************

	let loaderPromise = null;
	function load(callback) {
		if (!loaderPromise) {
			loaderPromise = new Promise(function(resolve) {
				Modules.loadScript("https://api.mapy.cz/loader.js", function() {
					Loader.async = true;
					Loader.load(null, null, function() {
						resolve();
					});
				});
			});
		}

		loaderPromise.then(callback);
	}

	// *************************************************************************
	// Main map in contacts
	// *************************************************************************

	onDocumentReady(function() {
		let element = document.getElementById("map");
		if (element) {
			load(function() {
				initContactsMap(element);
			});
		}
	});

})();
